export const environment = {
    production: true,
    sentryDSN: "https://0e80378f6110402babb5cc63368f145f@sentry.dokku.intothesource.com/23",
    gaCode: "UA-152521637-2",
};
